import TeamMembersTable from '../../Tables/TeamMembersTable';

const TeamMembersTab = () => {
    return <TeamMembersTable />;
};

export default TeamMembersTab;
